<div mat-dialog-title class="flex flex-row items-center justify-between border-b border-gray-200 px-6 py-2 mb-4">
  <h3 class="flex-1 m-0 font-semibold">{{ 'poi.filters' | translate }}</h3>
  <flow-button class="absolute right-4 top-3" theme="light" type="button" [mat-dialog-close]="true">
    <app-icon stroke="#202020" size="md" iconName="x"></app-icon>
  </flow-button>
</div>

<mat-dialog-content class="overflow-hidden">
  <div [formGroup]="filterForm" class="flex flex-col gap-4">
    <div class="flex flex-col">
      <mat-label>{{ 'poi.form.text' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <input formControlName="text" matInput type="text" placeholder="{{ 'poi.form.text' | translate }}" />
      </mat-form-field>
    </div>

    <div class="flex flex-col" *ngIf="isAdmin">
      <mat-label>{{ 'poi.form.customer' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <mat-select formControlName="customerIds" placeholder="{{ 'poi.form.customer' | translate }}">
          <mat-option *ngFor="let customer of customers" [value]="customer.id">
            {{ customer.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex flex-col">
      <mat-label>{{ 'poi.form.categories' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <mat-select placeholder="{{ 'poi.form.categories' | translate }}" formControlName="categories" multiple>
          <mat-option *ngFor="let category of categories" [value]="category.id">
            {{ category.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex flex-col">
      <mat-label>{{ 'poi.form.tags' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <mat-select formControlName="tags" placeholder="{{ 'poi.form.tags' | translate }}" multiple>
          <mat-option *ngFor="let tag of tags" [value]="tag.id">
            {{ tag.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <flow-form-date-range-picker
      formControlName="created"
      label="poi.form.datePickerLabel"
      fromPlaceholder="poi.form.datePickerFrom"
      toPlaceholder="poi.form.datePickerTo"></flow-form-date-range-picker>
  </div>
</mat-dialog-content>
<div mat-dialog-actions class="flex flex-row justify-between w-full items-center p-6 pt-0">
  <flow-button theme="secondary" variation="outline" (onClick)="clearForm()">{{ 'poi.clearAll' | translate}}</flow-button>
  <flow-button theme="primary" variation="fill" (onClick)="filter()">{{ 'poi.filter' | translate }}</flow-button>
</div>
